export default __webpack_public_path__ + "static/media/other.fcc35666.svg";